import {ChangeDetectionStrategy, Component} from '@angular/core';
import {MatDialog} from "@angular/material/dialog";
import {AuthService} from "../../_services/auth.service";
import {DynamicSettings} from "../../_types/shared";
import {DatePipe} from "@angular/common";
import {RouterModule} from "@angular/router";

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrl: './footer.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [DatePipe, RouterModule],
})
export class FooterComponent {
    dynamicSettings: DynamicSettings | null = null;
    today: Date = new Date();

    constructor(public dialog: MatDialog, private authService: AuthService) {
        this.authService.getDynamicSettings().then((r): void => {
            this.dynamicSettings = r;
        });
    }
}
